var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isauthenticated)?_c('v-main',[_vm._v("Not Authenticated")]):_c('v-main',[_c('Carousel'),_c('Advantage'),_c('Features'),_c('Subjects'),_c('BrandPartners'),_c('Foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }